module.exports = __webpack_public_path__ + "img/footer-img-mzke.e82a781.jpg";